import { gql } from '@apollo/client';

export default gql`
  mutation UpdateProvider($input: updateProviderInput) {
    updateProvider(input: $input) {
      id
    }
  }
`;
